import InfiniteScroll from 'react-infinite-scroll-component'
import styled from 'styled-components'
import { Button } from '@material-ui/core'
import { useTranslation } from 'i18n'
import Loading from '../Loading'

export function Pagination({
  loading,
  error,
  EmptyView = null,
  ErrorView = null,
  infiniteScroll = false,
  onLoadMore,
  pageInfo,
  repeat = 1,
  edges,
  renderItem,
  scrollableTarget = null,
}) {
  return (
    <div style={{ width: '100%' }}>
      {loading ? (
        <Loading />
      ) : error ? (
        ErrorView ? (
          ErrorView
        ) : (
          <p>{error.message}</p>
        )
      ) : edges.length ? (
        infiniteScroll ? (
          <InfinitePagination
            {...{
              onLoadMore,
              pageInfo,
              repeat,
              edges,
              renderItem,
              scrollableTarget,
            }}
          />
        ) : (
          <ManualPagination
            {...{ onLoadMore, pageInfo, repeat, edges, renderItem }}
          />
        )
      ) : (
        EmptyView
      )}
    </div>
  )
}

export function ManualPagination({
  onLoadMore,
  repeat = 1,
  edges,
  pageInfo,
  renderItem,
}) {
  const { t } = useTranslation('common')

  return (
    <Grid repeat={repeat}>
      {edges.map(({ node }, index) => renderItem(node, index))}
      {pageInfo?.hasNextPage && (
        <div style={{ gridColumn: 1, textAlign: 'center' }}>
          <Button onClick={onLoadMore}>{t('loadMore')}</Button>
        </div>
      )}
    </Grid>
  )
}

export function InfinitePagination({
  onLoadMore,
  pageInfo,
  repeat = 1,
  edges,
  renderItem,
  scrollableTarget,
}) {
  return (
    <InfiniteScroll
      dataLength={edges.length}
      next={onLoadMore}
      hasMore={pageInfo?.hasNextPage}
      loader={
        <div style={{ gridColumn: 1, textAlign: 'center', margin: 100 }}>
          <Loading />
        </div>
      }
      scrollableTarget={scrollableTarget}
    >
      <Grid repeat={repeat}>
        {edges.map(({ node: item }, index) => renderItem(item, index))}
      </Grid>
    </InfiniteScroll>
  )
}

const Grid = styled.div<{ repeat: number }>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(${props => props.repeat}, 1fr);
`
